var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { GraphicsType } from '../../../../shared/helpers/graphics-type-help';
import { finalize } from 'rxjs/operators';
import { ConfigureComponentBase } from '../../../../../../shared/configure-component-base';
import { GraphService } from '../../../../../../shared/gallery/graph.service';
var GallerySysComponent = /** @class */ (function (_super) {
    __extends(GallerySysComponent, _super);
    function GallerySysComponent(injector, sysGalleryService) {
        var _this = _super.call(this, injector) || this;
        _this.sysGalleryService = sysGalleryService;
        _this.currentGraphStateList = [];
        _this.currentGraphStateId = 0;
        _this.graphCategories = [];
        _this.graphList = [];
        _this.selectedGraphChange = new EventEmitter();
        return _this;
    }
    GallerySysComponent.prototype.loadGraphCategoies = function () {
        var _this = this;
        this.sysGalleryService.getCategories().subscribe(function (categories) {
            _this.graphCategories = categories;
            if (_this.graphCategories && _this.graphCategories.length) {
                _this.changeCategory(_this.graphCategories[0]);
            }
        });
    };
    GallerySysComponent.prototype.changeCategory = function (category) {
        var _this = this;
        this.selectedCategory = category;
        abp.ui.setBusy('#system-gallery');
        this.sysGalleryService.getGraphs(category.id).pipe(finalize(function () { return abp.ui.clearBusy('#system-gallery'); })).subscribe(function (graphs) {
            _this.graphList = [];
            _.each(graphs, function (graph) {
                var item = {
                    id: graph.id,
                    name: graph.name,
                    thumbUrl: ['/systemgallery', category.id, graph.id, graph.thumbUrl].join('/')
                };
                _this.graphList.push(item);
            });
            if (_this.graphList && _this.graphList.length) {
                _this.changeGraph(_this.graphList[0]);
                _this.selectedGraph = _this.graphList[0];
            }
            else {
                _this.selectedGraph = undefined;
            }
        });
    };
    GallerySysComponent.prototype.changeGraph = function (graph) {
        var _this = this;
        if (this.selectedGraph && this.selectedGraph.id === graph.id) {
            return;
        }
        this.sysGalleryService.getGraphStates(this.selectedCategory.id, graph.id).subscribe(function (states) {
            _this.currentGraphStateList = [];
            _.each(states, function (state) {
                var stateGraph = {
                    id: state.id,
                    name: _this.lc('State') + state.id,
                    type: state.type
                };
                stateGraph.url = [GraphService.systemUrl, _this.selectedCategory.id, graph.id, state.url].join('/');
                _this.currentGraphStateList.push(stateGraph);
            });
            if (_this.currentGraphStateList.length > 0) {
                _this.currentGraphStateId = _this.currentGraphStateList[0].id;
            }
            _this.currentGraph = {};
            _this.currentGraph.list = _this.currentGraphStateList;
            _this.currentGraph.name = graph.name;
            _this.currentGraph.categoryId = _this.selectedCategory.id;
            _this.currentGraph.graphId = graph.id;
            _this.currentGraph.graphicsType = GraphicsType.system;
            _this.selectedGraphChange.emit(_this.currentGraph);
        });
        this.selectedGraph = graph;
    };
    __decorate([
        Output()
    ], GallerySysComponent.prototype, "selectedGraphChange", void 0);
    GallerySysComponent = __decorate([
        Component({
            selector: 'gallery-sys',
            styles: [".gallery-wrap { ul { list-style: none; padding: 0; margin: 0; } li { cursor: pointer; } a:focus, a:hover { color: #2889d0; border: none; } a:active, a:hover { outline: 0; } .listLink { display: block; text-decoration: none; color: #303030; padding: 8px 12px 8px 10px; text-overflow: ellipsis; } .listLink:hover { text-decoration: none; background: #EEEEEE; } .listLinkSelected { display: block; text-decoration: none; padding: 8px 12px 8px 10px; background: #EEEEEE; border: 1px solid #EEEEEE; } a { color: #EEEEEE; text-decoration: none; } .graphSettingBox { height: 255px; border: 1px solid #ddd; overflow-x: auto; display: block; .font12Size { font-size: 12px; } .selectedType { background: #EEEEEE; } } .graphType { width: 140px; float: left; height: 400px; margin-right: 10px; } .graphBoxes { width: 78%; } .stateBox { height: 140px; margin-top: 5px; border: none; } .colorPick { width: 50px; } .span-inline-block { display: inline-block; width: 100%; } .backgroundBorder { padding: 5px; border: 1px solid #ddd; } .graphBtns button { height: 26px; line-height: 22px; margin-right: 10px; } }"],
            template: "<div id='system-gallery' class='gallery-wrap clearfix' style=\"border: 0;\"> <div class=\"form-group border-group\"> <div class=\"graphSettingBox graphType\"> <ul *ngFor=\"let category of graphCategories\"> <li [class.selectedType]=\"category.id==selectedCategory.id\"> <a class=\"listLink\" tooltip=\"{{category.name}}\" (click)=\"changeCategory(category)\">{{category.name}}</a> </li> </ul> </div> <div style=\"display: flow-root;\"> <div class=\"graphSettingBox graphBox\"> <graph-list [graphList]=\"graphList\" (graphSelected)=\"changeGraph($event)\" [selectedGraphId]=\"selectedGraph?.id\"></graph-list> </div> <div class=\"graphSettingBox stateBox\"> <div>{{lc(\"State\")}}:</div> <graph-state-list [stateList]=\"currentGraphStateList\" [selectedStateId]=\"currentGraphStateId\"></graph-state-list> </div> </div> </div> </div> "
        })
    ], GallerySysComponent);
    return GallerySysComponent;
}(ConfigureComponentBase));
export { GallerySysComponent };
